import { getEnvName } from './getEnvName';

export const ConfigUtils = {
  getEnvName,
};
